import SupplierSelector from './src/main';

/* istanbul ignore next */
SupplierSelector.install = function(Vue) {
  Vue.component(SupplierSelector.name, SupplierSelector);
};

export default SupplierSelector;
